<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_xvi"></a><a id="page_xvii"></a><a id="after"></a><em>after Rilke</em></h2>
<p class="noindent">Closed up like a mouth after a cry</p>
<p class="noindent">the white house has its blinds all drawn.</p>
<p class="noindent">Out on the sundial, a peacock lies,</p>
<p class="noindent">causing mid-day hours to be gone.</p>
<p class="noindentt">The roses will lose themselves tonight,</p>
<p class="noindent">too full of petalling, in gentle agonies.</p>
<p class="noindent">My child, my friend, do not refuse the sight:</p>
<p class="noindent">for death gives life its clarities.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// after.vue?4d7b01b0